import { bindable, autoinject } from 'aurelia-framework';
import { IEditedTemplate, ReportFormMode } from '../report-edit';
import { ValidationController, ValidationControllerFactory, ValidationRules } from 'aurelia-validation';

@autoinject
export class EditReportControls {
	@bindable templateName: string;
	@bindable templateIsPrivate: boolean;
	@bindable saveAsNewName: string;
	@bindable saveAsNewIsPrivate: boolean;
	@bindable update: () => void;
	@bindable saveAsNew: (params: { editedTemplate: IEditedTemplate }) => void;
	@bindable nameChange: (params: { name: string }) => void;

	saveAsNewVisible: boolean;

	private validationController: ValidationController;

	constructor(private validationControllerFactory: ValidationControllerFactory) {
		this.validationController = validationControllerFactory.createForCurrentScope();
		ValidationRules.ensure((vm: EditReportControls) => vm.saveAsNewName)
			.required()
			.withMessageKey('ReportEditControls_Validation_NameIsRequired')
			.on(this);
	}

	attached() {
		this.saveAsNewIsPrivate = this.templateIsPrivate;
	}

	onUpdate() {
		this.update();
	}

	async onSaveAsNew() {
		const result = await this.validationController.validate({ object: this });

		if (!result.valid) { return; }

		this.saveAsNew({ editedTemplate: { name: this.saveAsNewName, isPrivate: this.saveAsNewIsPrivate } });
		this.saveAsNewVisible = false;
	}

	onNameChange(value: string) {
		this.nameChange({ name: value });
	}
}
